import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent {
  @Input() identifier: string;
  @Input() name: string;
  @Input() required: boolean = false;
  @Input() inline: boolean;
  @Input() card: boolean;
  @Input() disabled: boolean;

  @Input() selected: boolean;
  @Output() changed = new EventEmitter<boolean>();

  @ViewChild('labelRef', { static: true }) labelRef: ElementRef;

  @HostBinding('class.bare')
  get bare() {
    return (
      !this.labelRef || this.labelRef.nativeElement.childNodes.length === 0
    );
  }

  @ViewChild('radioElement', { static: false }) radioElement: ElementRef;

  focus() {
    this.radioElement.nativeElement.focus();
  }
}
